import { RecordDataSource } from "../../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  RecordGridViewService,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";

import { vsObjectName as MachineProgressiveGameName } from "./machineProgressiveGame";

export const vsObjectName = "machineProgressiveGameLevel";

machineProgressiveGameLevelConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];
export function machineProgressiveGameLevelConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  registerGrid(
    recordGridViewServiceProvider,
    columnDefinitionSetServiceProvider
  );
}

function registerGrid(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    RecordGridViewServiceName,
    ServerUtilityName,
    GridSettingsServiceName,
    (
      recordGridViewService: RecordGridViewService,
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService
    ) => {
      const machineProgressiveGameGridConfiguration =
        recordGridViewService.getGridConfiguration(MachineProgressiveGameName)!;
      return {
        columnDefinitionSet: vsObjectName,
        defaultSort: RecordGridViewService.combineSort(
          machineProgressiveGameGridConfiguration.defaultSort,
          "MachineProgressiveGameLevelOrder"
        ),
        gridSettings: gridSettingsService.getGridSettings(Symbol(vsObjectName)),
        namePlural: "Levels",
        nameSingular: "Level",
        gridDataSource: new RecordDataSource(
          serverUtility,
          "/api/machines/MachineProgressiveGameLevel"
        ),
      };
    },
  ]);

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    RecordGridViewServiceName,
    ColumnDefinitionServiceName,
    (
      recordGridViewService: RecordGridViewService,
      columnDefinitionService: ColumnDefinitionService
    ) => {
      const machineProgressiveGameGridConfiguration =
        recordGridViewService.getGridConfiguration(MachineProgressiveGameName)!;
      return [
        columnDefinitionService.getStringColDef({
          field: "MachineProgressiveGameLevelName",
          header: "Level",
        }),
        ...(machineProgressiveGameGridConfiguration.columns ?? []),
      ];
    },
  ]);
}
